import React from 'react';
import Image from 'next/image';
import { Container, Row, Col } from 'react-bootstrap';
import { useSafeTemplateData } from '@/hooks/useSafeTemplateData';
import { ToggleTax } from './Components/ToggleTax';
import styles from './Header.module.scss';
import { UserArea } from './Components/UserArea';

export const CartHeader = () => {
  const templateData = useSafeTemplateData();

  if (!templateData) {
    return (
      <header className={`${styles.cartHeader} ${styles.header}`}>
        <Container>
          <Row>
            <Col className="d-flex justify-content-end">
              <div>Loading...</div>
            </Col>
          </Row>
        </Container>
      </header>
    );
  }

  return (
    <>
      <header className={`${styles.cartHeader} ${styles.header}`}>
        <Container>
          <Row>
            <Col className="d-flex justify-content-end">
              <a href={'/'}>
                <Image
                  src={templateData.sector.logo}
                  alt="Carel Lurvink logo"
                  width={60}
                  height={50}
                  className={styles.cartHeaderLogo}
                  priority
                />
              </a>
              <Col xs={{ span: '5', order: 3 }} sm={{ span: 'auto', order: 3 }} className="d-block align-self-center pt-1 ml-auto">
                <UserArea />
              </Col>
              <ToggleTax />
            </Col>
          </Row>
        </Container>
      </header>
    </>
  );
};
